/// <reference types="./blocks.d.mts" />
import * as $unsafe from "../../../common_common/gleam/unsafe.mjs";
import * as $colors from "../../../ds/ds/colors.mjs";
import * as $text from "../../../ds/ds/typography/text.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../lustre/lustre/element.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $element from "../../../sketch_lustre/sketch/lustre/element.mjs";
import * as $events from "../../elements/editors/blocks/tiptap/events.mjs";
import * as $transaction from "../../elements/editors/shared/tiptap/transaction.mjs";
import { toList } from "../../gleam.mjs";

export function view(is_hint, attributes) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.regular)),
      $css.position("relative"),
      $css.white_space("pre-wrap"),
      $css.background($colors.light.text_white),
      $css.color(
        (() => {
          if (is_hint) {
            return $colors.light.grey_600;
          } else {
            return $colors.light.text_body;
          }
        })(),
      ),
      $css.focus(toList([$css.outline("none")])),
    ]),
  );
  return ((_capture) => {
    return $element.element("blocks-tiptap", _capture, attributes, toList([]));
  })(_pipe);
}

export function content(content) {
  let content$1 = $json.string(content);
  return $a.property("content", content$1);
}

export function editable(editable) {
  let editable$1 = $bool.to_string(editable);
  return $a.attribute("editable", editable$1);
}

function generate_empty_handlers() {
  return $list.map(
    $events.empty,
    (_use0) => {
      let name = _use0[0];
      let msg = _use0[1];
      return $e.on(name, $decode.success(msg));
    },
  );
}

function generate_transaction_handlers() {
  return $list.map(
    $events.transactions,
    (_use0) => {
      let name = _use0[0];
      let msg = _use0[1];
      return $e.on(
        name,
        (() => {
          let _pipe = $transaction.decoder();
          return $decode.map(_pipe, msg);
        })(),
      );
    },
  );
}

function on_connected() {
  return $e.on(
    "connected",
    (() => {
      let _pipe = $decode.at(toList(["detail", "editor"]), $decode.dynamic);
      let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
      return $decode.map(
        _pipe$1,
        (var0) => { return new $events.Connected(var0); },
      );
    })(),
  );
}

function on_updated() {
  return $e.on(
    "updated",
    (() => {
      let _pipe = $decode.at(toList(["detail"]), $decode.dynamic);
      let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
      return $decode.map(
        _pipe$1,
        (var0) => { return new $events.Updated(var0); },
      );
    })(),
  );
}

export function on_events() {
  let empty = generate_empty_handlers();
  let transactions = generate_transaction_handlers();
  let _pipe = $list.append(empty, transactions);
  let _pipe$1 = $list.prepend(_pipe, on_connected());
  return $list.prepend(_pipe$1, on_updated());
}
